import LinkS3 from "./LinkS3";

export default LinkS3